import React, { useEffect, useState } from 'react';
import ClassroomModal from './ClassroomModal';

interface NameTeamModalProps {
  isOpen: boolean;
  mode: 'create' | 'rename';
  initialName?: string;
  busy?: boolean;
  onClose: () => void;
  onSubmit: (name: string) => void | Promise<void>;
}

const NameTeamModal: React.FC<NameTeamModalProps> = ({
  isOpen,
  mode,
  initialName = '',
  busy,
  onClose,
  onSubmit,
}) => {
  const [name, setName] = useState(initialName);

  useEffect(() => {
    if (isOpen) setName(initialName || '');
  }, [isOpen, initialName]);

  const title = mode === 'rename' ? 'Rename team' : 'Name this team';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed || busy) return;
    await onSubmit(trimmed);
  };

  return (
    <ClassroomModal isOpen={isOpen} title={title} onClose={onClose} width={440}>
      <form onSubmit={handleSubmit} className="cd-modal-form">
        <label className="cd-field">
          <span className="cd-field-label">Team name</span>
          <input
            className="cd-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. The Story Sharks"
            autoFocus
            maxLength={48}
            disabled={busy}
          />
        </label>
        <p className="cd-modal-hint">
          Kids will see this name on the board and in their portfolio all season.
        </p>
        <div className="cd-modal-actions">
          <button type="button" className="cd-btn" onClick={onClose} disabled={busy}>
            Cancel
          </button>
          <button
            type="submit"
            className="cd-btn cd-btn-primary"
            disabled={busy || !name.trim()}
          >
            {busy ? 'Saving…' : mode === 'rename' ? 'Save' : 'Create team'}
          </button>
        </div>
      </form>
    </ClassroomModal>
  );
};

export default NameTeamModal;
